import type { GroupBase, MultiValueProps } from 'react-select';

import { useMultiValueConfiguration } from './hooks/multi-value-configuration.hook';

/**
 * MultiValue component for react-select.
 *
 * This component leverages the `useMultiValueConfiguration` hook to determine
 * the appropriate component to render for a multi-value item in a select input.
 *
 * @template Option - The option type.
 * @template IsMulti - Boolean indicating if multi-select is enabled.
 * @template Group - The group type, extending GroupBase.
 *
 * @param props - The props conforming to `MultiValueProps` from react-select.
 * @returns The configured multi-value component.
 */
function MultiValue<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: MultiValueProps<Option, IsMulti, Group>
) {
  const { Component } = useMultiValueConfiguration(props);

  return Component;
}

export default MultiValue;
